import React, { Component } from "react";


import AcuerdoTerminosCondiciones from "../../components/Acuerdo_TerminosCondiciones";

// -----------Importar Componentes de Terceros------------------
// import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';



import Grid from '@mui/material/Grid';


import logo from '../../assets/Imagenes/Aviso_Privacidad/Cuadros.png'

class TerminosCondiciones extends Component {
  state = {
    Error: '',
  }
 scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
   componentDidMount() {
    this.scrollToTop();
  }

  render() {
    return (



      <Box sx={{ margin: '5% 15px !important' }}>
        <Container sx={{ padding: '0px !important', maxWidth: '1200px !important' }}>

          <Grid container spacing={1} columns={12}>
            <Grid item xs={12} md={10} sx={{ display: 'flex', justifyContent: 'center' }}>
              <AcuerdoTerminosCondiciones />
            </Grid>
            <Grid item xs={2} md={2}  >
              <Box width='100%' sx={{ display:{xs:'none', sm:'flex'}, justifyContent: 'flex-end' }}>
                <img width='85%' alt="Logo aviso de privacidad" src={logo}></img>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }
}

export default TerminosCondiciones;

